<template>
  <div class="content">
    <div class="top">
      <div class="el-steps-box">
        <el-steps :active="1" finish-status="success" simple>
          <el-step :title=ApplicationSelection></el-step>
          <el-step :title=AppLoadconditions></el-step>
          <el-step :title=ReducerLoadconditions></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <!-- 内容页 -->
    <div class="appPic">
      <img src="../../../../static/appPic/app01.png" alt="">
    </div>
    <h3 class="appPic_title">{{$t('message.zhuantai_1')}}</h3>
    <el-tabs class="app_item" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label=loadCondition name="first">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="app_item_form">
          <el-form-item :label=zhuantai_2 prop="r">
            <span class="first_span">r</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.r" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_3 prop="m">
            <span class="first_span">m</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.m" auto-complete="off"></el-input>
            <span>(kg)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_4 prop="Rw">
            <span class="first_span">Rw</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Rw" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_5 prop="Mw">
            <span class="first_span">Mw</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Mw" auto-complete="off"></el-input>
            <span>(kg)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_6 prop="Xw">
            <span class="first_span">Xw</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Xw" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_7>
            <el-radio-group style="padding-left:50px;" v-model="form.connect" @change="change">
              <el-radio :label=zhuantai_8></el-radio>
              <el-radio :label=zhuantai_9></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label=zhuantai_10 v-show="D" prop="D">
            <span class="first_span">D</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.D" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_11 v-show="u" prop="u">
            <span class="first_span">μ</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.u" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label=Operationmode name="second">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="app_item_form">
          <el-form-item :label=zhuantai_12 prop="t1">
            <span class="first_span">t1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t1" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_13 prop="t2">
            <span class="first_span">t2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t2" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_14 prop="t3">
            <span class="first_span">t3</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t3" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_15 prop="t4">
            <span class="first_span">t4</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t4" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_16 prop="n2">
            <span class="first_span">n2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.n2" auto-complete="off"></el-input>
            <span>(r/min)</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 按钮 -->
    <div class="button_box">
      <span class="button" @click="renturnPrePage">{{$t('message.Return')}}</span>
      <span class="button" @click="toNextPage">{{$t('message.Next')}}</span>
    </div>
  </div>
</template>
<script>
  import {
    transTurnTable
  } from '@/store/electric_app'
  export default {
    name: 'SelectedTurnTable',
    data() {
      return {
        activeName: 'first',
        form: {
          r: '',
          m: '',
          Rw: '',
          Mw: '',
          Xw: '',
          t1: '',
          t2:'',
          t3:'',
          t4:'',
          n2:'',
          D: '',
          u: '',
          connect:''
        },
        rules: {
          r: [
            {required: true, message:'此项不能为空'},

          ],
          m: [
            {required: true, message:'此项不能为空'},

          ],
          Rw: [
            {required: true, message:'此项不能为空'},

          ],
          Mw: [
            {required: true, message:'此项不能为空'},

          ],
          Xw: [
            {required: true, message:'此项不能为空'},

          ],
          t1: [
            {required: true, message:'此项不能为空'},

          ],
          t2:[
            {required: true, message:'此项不能为空'},

          ],
          t3:[
            {required: true, message:'此项不能为空'},

          ],
          t4:[
            {required: true, message:'此项不能为空'},

          ],
          n2:[
            {required: true, message:'此项不能为空'},

          ],
          D: [

          ],
          u: [

          ],
        },
        D:false,
        u:false,
        param:{},
        ApplicationSelection:this.$t('message.ApplicationSelection'),
        AppLoadconditions:this.$t('message.AppLoadconditions'),
        ReducerLoadconditions:this.$t('message.ReducerLoadconditions'),
        reducerSize:this.$t('message.reducerSize'),
        selectMotor:this.$t('message.selectMotor'),
        complete:this.$t('message.complete'),
        loadCondition:this.$t('message.loadCondition'),
        Operationmode:this.$t('message.Operationmode'),
        zhuantai_2:this.$t('message.zhuantai_2'),
        zhuantai_3:this.$t('message.zhuantai_3'),
        zhuantai_4:this.$t('message.zhuantai_4'),
        zhuantai_5:this.$t('message.zhuantai_5'),
        zhuantai_6:this.$t('message.zhuantai_6'),
        zhuantai_7:this.$t('message.zhuantai_7'),
        zhuantai_8:this.$t('message.zhuantai_8'),
        zhuantai_9:this.$t('message.zhuantai_9'),
        zhuantai_10:this.$t('message.zhuantai_10'),
        zhuantai_11:this.$t('message.zhuantai_11'),
        zhuantai_12:this.$t('message.zhuantai_12'),
        zhuantai_13:this.$t('message.zhuantai_13'),
        zhuantai_14:this.$t('message.zhuantai_14'),
        zhuantai_15:this.$t('message.zhuantai_15'),
        zhuantai_16:this.$t('message.zhuantai_16'),
      };
    },
    mounted(){
      var lang = localStorage.getItem('lang');
      if(lang == 'cn'){
        this.form.connect = '直接结合';
      }else if(lang == 'en'){
        this.form.connect = 'Direct coupling';
      }
    },
    methods: {
      toNextPage:function(){
        if(this.form.t1 == '' && this.form.t2 == '' && this.form.t3 == '' && this.form.t4 == '' && this.form.n2 == ''){
          this.$message({
            message: '请检查 减速机负载 与 运转模式 是否都已填写!',
            type: 'warning'
          });
        }else{
          if(!this.form.D){
            delete this.form.D;
          }
          if(!this.form.u){
            delete this.form.u;
          }
          if(this.form.connect == '直接结合' || this.form.connect == 'Direct coupling'){
            delete this.form.D;
            delete this.form.u;
          }
          transTurnTable(this.form).then((response)=>{
            if(response.success === true){
              this.$emit("listenParam",response.data)
              this.$emit("listenPageChange","to_ReducerLoadPage")
              sessionStorage.setItem('childPageName','to_TurnTablePage')
            }else{
              this.$message({
                message: '转台参数各项不能为空!',
                type: 'warning'
              });
            }
          })
        }
      },
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_AppPage")
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      change(val) {
        if(val === '连轴器' || val === 'Couping'){
          this.D = true
          this.u = true
        }else{
          this.D = false
          this.u = false
        }
      }
    }
  };
</script>
<style scoped>
  /* 转台 */
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    padding-bottom:20px;
    background-image: url('../../../../static/load02.png');
    background-repeat:no-repeat;
    background-position-x:right 100px;
    background-position-y:435px;
  }
  @media screen and (-webkit-min-device-pixel-ratio:0){
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:90%;
      background-position-y:435px;
    }
  }
  .top {
    height:120px;
    border-bottom:1px solid #EBEBEB;
  }
  .el-steps-box {
    width:90%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../../static/step.png') no-repeat #F5F7FA;
    background-size:18% 100%;
    background-position-x:24%;
  }
  .el-tabs {
    width:66%;
    margin:0 auto;
    margin-top:50px;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    background:#142479;
    color:#C6C6C6;
    text-align: center;
    line-height: 42px;
    border-radius: 10px;
    margin-left:15px;
    cursor: pointer;
  }
  .button_box {
    width:100%;
    text-align: center;
    padding-top:20px;
  }
  .app_item{
    margin-left:130px;
  }
  .app_item_form{
    margin-left:100px;
    margin-top:30px;
  }
  .app_item_form .el-input{
    width:60%;
    padding-left:30px;
  }
  .app_item_form .first_span{
    padding-left:50px;
    width:10px;
    display:inline-block;
  }
  .appPic {
    width:100%;
    margin:0 auto;
  }
  .appPic img {
    width:15%;
    height:15%;
    display:block;
    margin:0 auto;
    margin-top:20px;
  }
  .appPic_title {
    width:200px;
    margin:0 auto;
    text-align: center;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .app_item_form{
      margin-top:30px;
      margin-left:20px;
    }
    .app_item {
      margin-left:60px;
    }
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:right 60px;
      background-position-y:370px;
    }
    @media screen and (-webkit-min-device-pixel-ratio:0){
      .content {
        width:100%;
        height: 100%;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 15px rgb(224, 224, 224);
        padding-bottom:20px;
        background-image: url('../../../../static/load02.png');
        background-repeat:no-repeat;
        background-position-x:90%;
        background-position-y:370px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/SelectedAppLoad/SelectedTurnTable.vue